module.exports = __webpack_public_path__ + "img/11_L1.8f63eb3b.svg";